// src/pages/ListingsForSale.jsx
import React from "react";
import Listings from "./Listings";

export default function ListingsForSale() {
  return <Listings forcedListingType="sale" />;
}